import {getUserColor} from '@dms/shared';

/**
 * Neutral grey for the current user (always watched-list index 0). Matches the kanban
 * card's own neutral accent (palettes.neutral.300.100) so "mine" stays visually plain —
 * the current user keeps a grey avatar and an untinted card, as before the color rework.
 */
export const CURRENT_USER_COLOR = '#5E6C84';

/**
 * Avatar color (#RRGGBB) for a watched user by list position. Index 0 (the current user)
 * stays grey; everyone else gets a distinct Google-palette color that cycles past the
 * former 6-user limit. Mirrors getCardOwnerColor so a user's avatar and card tint share
 * the same hue.
 */
export function getWatchedUserColor(index: number): string {
  return index <= 0 ? CURRENT_USER_COLOR : getUserColor(index);
}
